<template lang="pug">
#decoration
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_decoration_mobile.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_decoration_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 Decoration Materials
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 On a continuous substrate, products made through processes such as printing, coating, laminating or pressing. Composite plastic building materials decoration products are made by hot pressing of multi-layer structure, generally 3-5 layer structure laminated, including wear-resistant layer (including UV treatment layer), printed decoration layer, middle material layer, base material layer, etc..
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative(:class="{ active: p_show[0].show }" @click='change("PVC")') PVC
      b-col.text-center(:class="{ active: p_show[1].show }" @click='change("APET")') APET
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p This product can be used with printing and embossing processing to produce elegant and beautiful decoration materials such as carved doors, curtains, side strips, floor tiles and wood grain panels.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
      b-row#apet_detail.detail.pb-5.py-md-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p This product has good heat resistance and good ductility, and is suitable for folding box products such as stationery, toys, cosmetics, gifts, etc., and can also be used for solvent-attached synthetic building materials. Because of its good heating and stretching effect, it is also suitable for the production of PET shrink film.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
    div.mask
    h2.text-center 
      span PVC Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_5
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.heating_100")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#specification.py-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
    div.mask
    h2.text-center 
      span  APET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_1
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC / APET Decoration Materials-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC RIGID FILM can be used with printing and embossing processing to produce elegant and beautiful decoration materials such as carved doors, curtains, side strips, floor tiles and wood grain panels. There are ceiling, carved doors, edge banding, overlay, floor tiles, etc.APET has good heat resistance and good ductility, and is suitable for folding box products such as stationery, toys, cosmetics, gifts, etc., and can also be used for solvent-attached synthetic building materials. Because of its good heating and stretching effect, it is also suitable for the production of PET shrink film. There is PETG.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, Building materials, Decorate, Ceiling, Door, Edge banding, Overlay, floor tiles, Pasting' },
            { name: 'og:title', content: 'PVC Decoration Materials-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'PVC RIGID FILM can be used with printing and embossing processing to produce elegant and beautiful decoration materials such as carved doors, curtains, side strips, floor tiles and wood grain panels. There are ceiling, carved doors, edge banding, overlay, floor tiles, etc.APET has good heat resistance and good ductility, and is suitable for folding box products such as stationery, toys, cosmetics, gifts, etc., and can also be used for solvent-attached synthetic building materials. Because of its good heating and stretching effect, it is also suitable for the production of PET shrink film. There is PETG.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Decoration Materials',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/decoration_img_01.jpg',
            img_alt: 'NAN YA  PVC is flame-resistant, impact-resistant and easy to process, APET has good heat resistance and heat ductility, Elegant and beautiful production of decorative materials.' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/decoration_img_02.jpg',
            img_alt: 'NAN YA  PVC is flame-resistant, impact-resistant and easy to process, APET has good heat resistance and heat ductility, Elegant and beautiful production of decorative materials.' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/decoration_img_03.jpg',
            img_alt: 'NAN YA  PVC is flame-resistant, impact-resistant and easy to process, APET has good heat resistance and heat ductility, Elegant and beautiful production of decorative materials.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: 'This product has the characteristics of flame resistance, impact resistance and easy processing. It can strengthen the weather resistance and increase the heat distortion temperature according to the purpose, which can meet the needs of building materials and decoration.' },
          { message: 'Meet the requirements of EU REACH and ROHS regulations.' }
        ],
        p_use: [
          { message: 'Customizable items: cold resistance, temperature resistance, weather resistance and flame resistance, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, JIS-K6734, etc.' }
        ],
        a_feature: [
          { message: 'Good heat resistance.' },
          { message: 'Good heating ductility.' }
        ],
        a_use: [
          { message: 'Customizable items: tanning, corona, cold resistance, anti-static, anti-fog and high frequency, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, ASTM D-1003 and ASTM D-523, etc.' }
        ],
        p_specification: [
          { 
            id: '1',
            name: 'VDDC(Ceiling)',
            feature: 'Features: Good weather resistance',
            outward: 'Appearance: Colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub>：0.06',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.38±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>300/CD>200</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/><span class="pl-5">MD>20/CD>20</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">-</span>',
            heating_100: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">MD＞-15/CD<7</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '2',
            name: 'VDDD(Door)',
            feature: 'Features: Good impact resistance and weather resistance',
            outward: 'Appearance: Colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.40 ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>120/CD>80</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-5~-7/CD<0.8</span>',
            heating_100: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">-</span>',
            vcm: 'VCM(ppm)</sub>：Unregulated' },
          { 
            id: '3',
            name: 'VDDE(Edge Banding)',
            feature: 'Features: Good impact resistance and weather resistance',
            outward: 'Appearance: Colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.30 ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>100/CD>50</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/> <span class="pl-5">MD-5~-7/CD<0.8</span>',
            heating_100: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">-</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '4',
            name: 'VDDU(Overlay)',
            feature: 'Features: Good printability, fit and flatness',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.065',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>70/CD>25</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/> <span class="pl-5">-</span>',
            heating_100: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">MD＞-13/CD<5</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '5',
            name: 'VLLTNS(Non-tin Series)',
            feature: 'Features: Environmental protection',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.07',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>80/CD>25</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/> <span class="pl-5">-</span>',
            heating_100: 'Heat Shrinkage<sub>(%,100°CX10min)</sub>：<br/><span class="pl-5">MD＞-10/CD<4</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'AYGG',
            feature: 'Features: Heat resistance and good ductility',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.55',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>:<br/><span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/><span class="pl-5">158～168</span>',
            mist: 'Haze<sub>(%)</sub>：<br/><span class="pl-5">≦4.5</span>'}
        ],
        swiperOption_pvc: {
          slidesPerView: 5,
          spaceBetween: 30,
          breakpoints: {
            1930: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption_apet: {
          slidesPerView: 1,
          spaceBetween: 30,
          breakpoints: {
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Food and Medical use',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'Antistatic Packaging',
            text:'Using blister equipment, using high temperature and molds, the flat plastic sheet is formed into a three-dimensional packaging curved shell, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'4',
            name:'Card Lamination',
            text:'This product can be processed into various cards through printing, laminating, card punching, coding, and sub-card quality inspection.',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'For Stationery',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process.',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'Cooling Tower',
            text:'Press working and forming process are good for the product.Forming process has to regulate quality.',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green Apet',
            text:'GREEN APET uses PCR resins made from recycled PET bottles as its raw material, reducing emissions of carbon and waste, providing consumers with an eco-friendly products.',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET SHEET',
            text:'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#decoration
  #specification
    background-image: url(../assets/bg/bg_decoration.jpg)


</style>
